<template>
  <article>
    <section>

      <div>
        <p class='page-body' v-html='extractIframe(page.body)'></p>
      </div>

    </section>
  </article>
</template>

<script>
export default {
  name: 'CustomPage',
  props: { page: { type: Object, required: true } },
  methods: {
    decodeHtmlEntities(str) {
      const textArea = document.createElement('textarea');
      textArea.innerHTML = str;
      return textArea.value;
    },
    removeQuotesFromIframe(html) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;

      const iframes = tempElement.querySelectorAll('iframe');
      iframes.forEach(iframe => {
        Array.from(iframe.attributes).forEach(attr => {
          if (attr.value.includes('"')) {
            attr.value = attr.value.replace(/"/g, '');
          }
        });
      });

      return tempElement.innerHTML;
    },
    extractIframe(htmlString) {
      const decodedContent = this.decodeHtmlEntities(htmlString);

      // Remove quotes from iframe attributes
      const contentWithoutQuotes = this.removeQuotesFromIframe(decodedContent);
      // Create a temporary DOM element to parse the content
      const tempElement = document.createElement('div');
      tempElement.innerHTML = contentWithoutQuotes;

      // Check if the content contains an iframe
      const iframes = tempElement.querySelectorAll('iframe');

      if (iframes.length > 0) {
        // Remove the pre tags
        const preTags = tempElement.querySelectorAll('pre.ql-syntax');
        preTags.forEach(tag => {
          // Replace pre tag with its inner HTML content
          const innerHTML = tag.innerHTML;
          // Create a temporary element to correctly parse innerHTML
          const tempInnerElement = document.createElement('div');
          tempInnerElement.innerHTML = innerHTML;
          tag.replaceWith(...tempInnerElement.childNodes);
        });
      }

      // Return the cleaned HTML
      return tempElement.innerHTML;
    }
  }
}
</script>

<style>
figure {
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 624px;
  }
}

.page-body {
  padding-bottom: 2rem;

  p {
    display: flex;

    &:has(img) + &:not(:has(img)),
    &:not(:has(img)) + &:has(img) {
      margin-top: 16px;
    }

    img {
      width: 55%;
      margin: 0 auto;
    }
  }
}
</style>
